import { getEventTransfer } from 'slate-react-old';
import { useContext, useEffect, useMemo, useRef } from 'react';

import ComposerContext from 'components/composer/contexts/composer_context';
import StartUpload from 'actions/composition/start_upload';
import useExecuteAction from 'components/hooks/use_execute_action';

export default function PasteAttachments(uploadFileRef) {
  return {
    onPaste(event, editor, next) {
      const { files } = getEventTransfer(event);

      // Only handle file pastes when a composition is available to upload to (e.g. the
      // note/task composers). Otherwise fall through to the default paste behavior.
      if (files && files.length > 0 && uploadFileRef.current) {
        for (const file of files) {
          uploadFileRef.current(file);
        }
        return true;
      }

      return next();
    },
  };
}

export function usePasteAttachmentsPlugin() {
  const { composition } = useContext(ComposerContext);
  const executeAction = useExecuteAction();
  const compositionId = composition?.id;

  const uploadFile = useMemo(() => {
    if (!compositionId) return null;
    return file => executeAction(StartUpload, { compositionId, file });
  }, [compositionId, executeAction]);

  const uploadFileRef = useRef(uploadFile);
  useEffect(() => {
    uploadFileRef.current = uploadFile;
  }, [uploadFile]);

  return useMemo(() => PasteAttachments(uploadFileRef), []);
}
